var _path, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeistungsdreieck000000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 58,
    viewBox: "0 0 101 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7506 9.41528L10.8826 28.7349L58.4479 47.5654L89.7506 9.41528Z",
    stroke: "#000000",
    strokeDasharray: "4 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7361,
    cy: 46.7094,
    r: 11.0048,
    fill: "#000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0048,
    cy: 27.6344,
    r: 11.0048,
    fill: "#000000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.9951,
    cy: 11.0048,
    r: 11.0048,
    fill: "#000000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeistungsdreieck000000);
export default __webpack_public_path__ + "static/media/leistungsdreieck_000000.19ac808231f76a85519a538225e5941a.svg";
export { ForwardRef as ReactComponent };